export const updateModuleVariables = (state, $) => {
  if ($.type === 'UPDATE_MODULE_VARIABLES') {
    const newState = {
      ...state,
      moduleVariables: {
        ...state.moduleVariables,
        ...$.data,
      },
    };

    // console.log(newState.moduleVariables);

    return newState;
  }

  return state;
};
